var map = {
	"./icon-beach.png": 3655,
	"./icon-city.png": 3656,
	"./icon-desert.png": 3657,
	"./icon-fairyland.png": 3658,
	"./icon-farm.png": 3659,
	"./icon-forest.png": 3660,
	"./icon-jungle.png": 3661,
	"./icon-lake.png": 3662,
	"./icon-mushrooms.png": 3663,
	"./icon-savannah.png": 3664,
	"./icon-sky.png": 3665,
	"./icon-space.png": 3666,
	"./icon-tundra.png": 3667,
	"./icon-underwater.png": 3668
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 706;



//////////////////
// WEBPACK FOOTER
// ./assets/images/skillset-icons .\.png*
// module id = 706
// module chunks = 0